import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAngleLeft,
  faAngleRight,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowRightLong,
  faArrowUp,
  faArrowUpRightFromSquare,
  faBars,
  faBriefcase,
  faBuilding,
  faBullhorn,
  faCalendar,
  faCalendarCheck,
  faCalendarPlus,
  faCalendarXmark,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCheck,
  faCircle,
  faCircleCheck,
  faCircleHalfStroke,
  faCircleNotch,
  faCircleQuestion,
  faCircleXmark,
  faClock,
  faClockRotateLeft,
  faCog,
  faCopy,
  faCut,
  faDisplay,
  faEnvelope,
  faExchange,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faFile,
  faFileCsv,
  faFileExcel,
  faFileLines,
  faFilter,
  faGauge,
  faGraduationCap,
  faHouse,
  faInfoCircle,
  faLocationDot,
  faLock,
  faLockOpen,
  faMinus,
  faMobile,
  faMoon,
  faPager,
  faPaste,
  faPeopleGroup,
  faPersonRunning,
  faPhone,
  faPlug,
  faPlus,
  faQuestion,
  faRightFromBracket,
  faRss,
  faSave,
  faSearch,
  faShieldHalved,
  faSort,
  faSortDown,
  faSortUp,
  faSpinner,
  faSquare,
  faSquareCheck,
  faSun,
  faThumbsDown,
  faThumbsUp,
  faTimes,
  faTrash,
  faTriangleExclamation,
  faTruck,
  faTruckFront,
  faUndo,
  faUser,
  faXmark
} from '@fortawesome/free-solid-svg-icons';
import { faHandshake, faEdit, faBell, faSquare as faSquareOpen } from '@fortawesome/free-regular-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';

const iconFactory = icon => {
  library.add(icon);
  const Icon = (props, ref) => <FontAwesomeIcon icon={icon} ref={ref} {...props} />;
  return React.forwardRef(Icon);
};

export const IconAngleLeft = iconFactory(faAngleLeft);
export const IconAngleRight = iconFactory(faAngleRight);
export const IconArrowDown = iconFactory(faArrowDown);
export const IconArrowLeft = iconFactory(faArrowLeft);
export const IconArrowRight = iconFactory(faArrowRight);
export const IconArrowRightLong = iconFactory(faArrowRightLong);
export const IconArrowUp = iconFactory(faArrowUp);
export const IconArrowUpRightFromSquare = iconFactory(faArrowUpRightFromSquare);
export const IconBars = iconFactory(faBars);
export const IconBell = iconFactory(faBell);
export const IconBriefcase = iconFactory(faBriefcase);
export const IconBuilding = iconFactory(faBuilding);
export const IconBullhorn = iconFactory(faBullhorn);
export const IconCalendar = iconFactory(faCalendar);
export const IconCalendarCheck = iconFactory(faCalendarCheck);
export const IconCalendarPlus = iconFactory(faCalendarPlus);
export const IconCalendarXmark = iconFactory(faCalendarXmark);
export const IconCaretDown = iconFactory(faCaretDown);
export const IconCaretLeft = iconFactory(faCaretLeft);
export const IconCaretRight = iconFactory(faCaretRight);
export const IconCheck = iconFactory(faCheck);
export const IconCircle = iconFactory(faCircle);
export const IconCircleCheck = iconFactory(faCircleCheck);
export const IconCircleHalfStroke = iconFactory(faCircleHalfStroke);
export const IconCircleInfo = iconFactory(faInfoCircle);
export const IconCircleNotch = iconFactory(faCircleNotch);
export const IconCircleQuestion = iconFactory(faCircleQuestion);
export const IconCircleXmark = iconFactory(faCircleXmark);
export const IconClock = iconFactory(faClock);
export const IconClockRotateLeft = iconFactory(faClockRotateLeft);
export const IconCog = iconFactory(faCog);
export const IconCopy = iconFactory(faCopy);
export const IconCut = iconFactory(faCut);
export const IconDashboard = iconFactory(faGauge);
export const IconDisplay = iconFactory(faDisplay);
export const IconEdit = iconFactory(faEdit);
export const IconEnvelope = iconFactory(faEnvelope);
export const IconExchange = iconFactory(faExchange);
export const IconExclamationTriangle = iconFactory(faExclamationTriangle);
export const IconEye = iconFactory(faEye);
export const IconEyeSlash = iconFactory(faEyeSlash);
export const IconFile = iconFactory(faFile);
export const IconFileCSV = iconFactory(faFileCsv);
export const IconFileExcel = iconFactory(faFileExcel);
export const IconFileLines = iconFactory(faFileLines);
export const IconFilter = iconFactory(faFilter);
export const IconGraduationCap = iconFactory(faGraduationCap);
export const IconHandshake = iconFactory(faHandshake);
export const IconHouse = iconFactory(faHouse);
export const IconLocationDot = iconFactory(faLocationDot);
export const IconLock = iconFactory(faLock);
export const IconLockOpen = iconFactory(faLockOpen);
export const IconMinus = iconFactory(faMinus);
export const IconMobile = iconFactory(faMobile);
export const IconMoon = iconFactory(faMoon);
export const IconPager = iconFactory(faPager);
export const IconPaste = iconFactory(faPaste);
export const IconPeopleGroup = iconFactory(faPeopleGroup);
export const IconPersonRunning = iconFactory(faPersonRunning);
export const IconPhone = iconFactory(faPhone);
export const IconPlug = iconFactory(faPlug);
export const IconPlus = iconFactory(faPlus);
export const IconQuestion = iconFactory(faQuestion);
export const IconRightFromBracket = iconFactory(faRightFromBracket);
export const IconRss = iconFactory(faRss);
export const IconSave = iconFactory(faSave);
export const IconSearch = iconFactory(faSearch);
export const IconShieldHalved = iconFactory(faShieldHalved);
export const IconSort = iconFactory(faSort);
export const IconSortDown = iconFactory(faSortDown);
export const IconSortUp = iconFactory(faSortUp);
export const IconSpinner = iconFactory(faSpinner);
export const IconSquare = iconFactory(faSquare);
export const IconSquareCheck = iconFactory(faSquareCheck);
export const IconSquareOpen = iconFactory(faSquareOpen);
export const IconSun = iconFactory(faSun);
export const IconThumbsDown = iconFactory(faThumbsDown);
export const IconThumbsUp = iconFactory(faThumbsUp);
export const IconTimes = iconFactory(faTimes);
export const IconTrash = iconFactory(faTrash);
export const IconTriangleExclamation = iconFactory(faTriangleExclamation);
export const IconTruck = iconFactory(faTruck);
export const IconTruckFront = iconFactory(faTruckFront);
export const IconUndo = iconFactory(faUndo);
export const IconUser = iconFactory(faUser);
export const IconXmark = iconFactory(faXmark);
